import { PROPOSAL_TEMPLATE_KEYS } from "./proposalTemplateConstants";
import ProposalPreviewBody from "./ProposalPreviewBody";
import LegacyProposalPreview from "./LegacyProposalPreview";
import { getSequenceForTemplateKey } from "./proposalTemplateConfig";

export { default as ProposalPreviewBody } from "./ProposalPreviewBody";
export { default as LegacyProposalPreview } from "./LegacyProposalPreview";
export {
  PROPOSAL_TEMPLATE_KEYS,
  PROPOSAL_TEMPLATE_OPTIONS,
} from "./proposalTemplateConstants";
export {
  ProposalHeadTermsSlide,
  ProposalTermsBlock,
  ProposalTermsHeader,
  ProposalTermsTable,
} from "./ProposalTermsSection";

/**
 * @returns {boolean} true when `proposalTemplateKey` selects a known multi-property template.
 */
export function resolveProposalTemplateKey(location) {
  const key = location?.proposalTemplateKey;
  if (!key || typeof key !== "string") return { isLegacy: true, key: null };
  const trimmed = key.trim();
  if (!PROPOSAL_TEMPLATE_KEYS.includes(trimmed)) {
    return { isLegacy: true, key: null };
  }
  if (!getSequenceForTemplateKey(trimmed)) {
    return { isLegacy: true, key: null };
  }
  return { isLegacy: false, key: trimmed };
}

export function ProposalPreviewRouter({
  createdProposal,
  rowvalue,
  totalHour,
  selectedRange,
  wrapInRow = true,
}) {
  const { isLegacy, key } = resolveProposalTemplateKey(createdProposal?.location);
  if (isLegacy) {
    return (
      <LegacyProposalPreview
        createdProposal={createdProposal}
        rowvalue={rowvalue}
        totalHour={totalHour}
        selectedRange={selectedRange}
        wrapInRow={wrapInRow}
      />
    );
  }
  return (
    <ProposalPreviewBody
      templateKey={key}
      imageBaseUrl={createdProposal?.proposalTemplateImageBaseUrl}
      createdProposal={createdProposal}
      rowvalue={rowvalue}
      totalHour={totalHour}
      selectedRange={selectedRange}
      wrapInRow={wrapInRow}
    />
  );
}
